import React from 'react';
import { StatefulTooltip as BWStatefulTooltip } from 'baseui/tooltip';
import { MIcon } from '../Icon';
import { overrides } from './overrides';
import { IDummyProps } from './types';

export const StatefulTooltip: React.FC<IDummyProps> = (props: IDummyProps) => {
	const { content, anchor = {}, ...rest } = props;
	const pos = props.placement ? props.placement : 'auto';
	const newContent = () => {
		return props.content ? (
			<div style={{ display: 'flex' }}>
				<span>{props.iconBefore && <MIcon icon={props.iconBefore} color="var(--epods--color-text-inverted)" />}</span>
				<span style={{ display: 'flex', color: 'var(--epods--color-text-inverted)' }}>{props.content}</span>
				<span>{props.iconAfter && <MIcon icon={props.iconAfter} color="var(--epods--color-text-inverted)" />}</span>
			</div>
		) : null;
	};
	const { Anchor, anchorProps } = anchor;

	return (
		<BWStatefulTooltip showArrow placement={pos} content={newContent} {...rest} overrides={overrides(props)}>
			{Anchor ? <Anchor {...anchorProps}>{props.children}</Anchor> : props.children}
		</BWStatefulTooltip>
	);
};
